import { useMutation } from '@tanstack/react-query'
import { finalizePurchase } from '@api/finalizePurchase'
import type {
  FinalizePurchasePayload,
  FinalizePurchaseResponse,
} from '@api/finalizePurchase'

export const useFinalizePurchase = () =>
  useMutation<{ data: FinalizePurchaseResponse; error?: string }, Error, FinalizePurchasePayload>({
    mutationFn: finalizePurchase,
  })

